import React from "react";
import Carousel from "react-bootstrap/Carousel";

export const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="header-section">
      <div className="header-content-container">
        <div className="text-content">
          <h1 className="main-title">
            <span className="sari-color-s">S</span>
            <span className="sari-color-a">a</span>
            <span className="sari-color-r">r</span>
            <span className="sari-color-i">i</span>
            <span className="sari-color-dash">~Sari</span> — Innovating the Way You Work
          </h1>
          <p className="subtitle">
            Custom Software. Smart Solutions. Real Results.
          </p>
          <div className="cta-buttons">
            <button 
              className="btn-get-started"
              onClick={() => scrollToSection("contact")}
            >
              Contact Us
            </button>
            <button 
              className="btn-secondary"
              onClick={() => scrollToSection("services")}
            >
              View Products
            </button>
          </div>
        </div>

        <div className="dashboard-display">
          <Carousel
            fade
            interval={3000}
            controls={false}
            indicators={true}
            pause={false}
            className="full-carousel"
          >
            <Carousel.Item>
              <img src="/img/bg.jpg" alt="First slide" />
            </Carousel.Item>
           
            <Carousel.Item>
              <img src="/img/intro1.jpg" alt="Third slide" />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </section>
  );
};
